export function normalizeAgentMcpUsername(value) {
  return String(value || '').trim().toLowerCase();
}

function utf8Binary(value) {
  if (typeof TextEncoder === 'function') {
    return Array.from(new TextEncoder().encode(value), byte => String.fromCharCode(byte)).join('');
  }

  return unescape(encodeURIComponent(value));
}

export function createBasicAuthorizationHeader(username, password) {
  const normalizedUsername = normalizeAgentMcpUsername(username);
  const credentials = `${normalizedUsername}:${String(password || '')}`;
  const encodeBase64 = typeof window !== 'undefined' && typeof window.btoa === 'function'
    ? window.btoa.bind(window)
    : btoa;

  return `Basic ${encodeBase64(utf8Binary(credentials))}`;
}
